import GreyBox from '@/components/common/GreyBox';
import WorkReportResultTable from '@/components/work/WorkReportResultTable';

const WorkReportDetailPage = () => {
  return (
    <GreyBox title='성능점검표' width='58.125rem'>
      <WorkReportResultTable isDetailPage />
    </GreyBox>
  );
};

export default WorkReportDetailPage;
